import { LayoutList, Link2 } from 'lucide-react';
import { ADMIN_GUARD } from '../admin-guard';
import { CONTEXTS, lazyView, type FeatureManifest } from '@/app/registry';
import { adminSkillGroupsRoutes } from './routes';
import { SKILL_LINK_TAB } from './skillGroupPanels';

export const adminSkillGroupsManifest: FeatureManifest = {
  id: 'admin-skill-groups',
  contexts: [
    CONTEXTS.ADMIN_SKILL_GROUPS,
    CONTEXTS.ADMIN_SKILL_GROUP_FORM,
    CONTEXTS.ADMIN_SKILL_GROUP_CREATE,
  ],

  routes: [
    {
      routes: adminSkillGroupsRoutes,
      errorFallbackLabel: 'Groupes de compétences',
      guard: ADMIN_GUARD,
    },
  ],

  centerView: {
    [CONTEXTS.ADMIN_SKILL_GROUPS]: lazyView(
      () => import('../views/AdminSkillGroupsListView'),
      'AdminSkillGroupsListView',
    ),
    [CONTEXTS.ADMIN_SKILL_GROUP_FORM]: lazyView(
      () => import('../views/AdminSkillGroupFormView'),
      'AdminSkillGroupFormView',
    ),
    [CONTEXTS.ADMIN_SKILL_GROUP_CREATE]: lazyView(
      () => import('../views/AdminSkillGroupFormView'),
      'AdminSkillGroupFormView',
    ),
  },

  panels: {
    left: {
      tabs: {
        [CONTEXTS.ADMIN_SKILL_GROUPS]: [
          {
            id: 'admin-nav',
            label: 'Navigation',
            icon: LayoutList,
            view: lazyView(() => import('../views/AdminNavView'), 'AdminNavView'),
          },
        ],
        [CONTEXTS.ADMIN_SKILL_GROUP_FORM]: [
          {
            id: 'admin-nav',
            label: 'Navigation',
            icon: LayoutList,
            view: lazyView(() => import('../views/AdminNavView'), 'AdminNavView'),
          },
        ],
        [CONTEXTS.ADMIN_SKILL_GROUP_CREATE]: [
          {
            id: 'admin-nav',
            label: 'Navigation',
            icon: LayoutList,
            view: lazyView(() => import('../views/AdminNavView'), 'AdminNavView'),
          },
        ],
      },
    },
    // Right panel: on-demand "link an existing skill" form (skill + grid + weight),
    // opened from the linked-skills editor. Same for edit and create contexts.
    right: {
      tabs: {
        [CONTEXTS.ADMIN_SKILL_GROUP_FORM]: [
          {
            id: SKILL_LINK_TAB,
            label: 'Lier une compétence',
            icon: Link2,
            view: lazyView(() => import('../views/AdminSkillLinkView'), 'AdminSkillLinkView'),
          },
        ],
        [CONTEXTS.ADMIN_SKILL_GROUP_CREATE]: [
          {
            id: SKILL_LINK_TAB,
            label: 'Lier une compétence',
            icon: Link2,
            view: lazyView(() => import('../views/AdminSkillLinkView'), 'AdminSkillLinkView'),
          },
        ],
      },
    },
  },

  enabledWhen: {
    roles: ['admin'],
  },

  panelRequirements: {
    [CONTEXTS.ADMIN_SKILL_GROUPS]: {
      left: { open: true, defaultActiveTab: 'admin-nav' },
      right: { open: false },
    },
    [CONTEXTS.ADMIN_SKILL_GROUP_FORM]: {
      left: { open: true, defaultActiveTab: 'admin-nav' },
      right: { open: false },
    },
    [CONTEXTS.ADMIN_SKILL_GROUP_CREATE]: {
      left: { open: true, defaultActiveTab: 'admin-nav' },
      right: { open: false },
    },
  },
};
